'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />
/* tslint:disable:no-unused-variable member-ordering */
var API;
(function (API) {
    var Client;
    (function (Client) {
        'use strict';

        var DefaultApi = function () {
            function DefaultApi($http, $httpParamSerializer, basePath) {
                _classCallCheck(this, DefaultApi);

                this.$http = $http;
                this.$httpParamSerializer = $httpParamSerializer;
                this.basePath = '/proxy/oag/gtw_rh';
                this.defaultHeaders = {};
                if (basePath) {
                    this.basePath = basePath;
                }
            }

            _createClass(DefaultApi, [{
                key: 'extendObj',
                value: function extendObj(objA, objB) {
                    for (var key in objB) {
                        if (objB.hasOwnProperty(key)) {
                            objA[key] = objB[key];
                        }
                    }
                    return objA;
                }
                /**
                 *
                 * Retrieve open contracts using the receiptId as parameter\n
                 * @param documentNumber The receiptId
                 */

            }, {
                key: 'agenciesDocumentNumberGet',
                value: function agenciesDocumentNumberGet(documentNumber, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/agencies/{documentNumber}'.replace('{' + 'documentNumber' + '}', String(documentNumber));
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'documentNumber' is set
                    if (!documentNumber) {
                        throw new Error('Missing required parameter documentNumber when calling agenciesDocumentNumberGet');
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
                /**
                 *
                 * Retrieve open contracts using the receiptId as parameter\n
                 * @param agencyData Agency data to be registered
                 */

            }, {
                key: 'agenciesPost',
                value: function agenciesPost(agencyData, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/agencies';
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'agencyData' is set
                    if (!agencyData) {
                        throw new Error('Missing required parameter agencyData when calling agenciesPost');
                    }
                    var httpRequestParams = {
                        method: 'POST',
                        url: localVarPath,
                        json: true,
                        data: agencyData,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
            }]);

            return DefaultApi;
        }();

        DefaultApi.$inject = ['$http', '$httpParamSerializer'];
        Client.DefaultApi = DefaultApi;
    })(Client = API.Client || (API.Client = {}));
})(API || (API = {}));